"use client";

import { c as _c } from "react/compiler-runtime";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { selectDemandZones } from "../demandLocation";
type DemandLocation = {
  id?: string;
  code?: string | null;
  parentId?: string | null;
  name?: string | null;
};

/**
 * A demand's location label: the first zone, plus "+N" when it targets more
 * than one — hovering the "+N" reveals all the zones.
 */
export function DemandLocationName(t0) {
  const $ = _c(37);
  const {
    locations
  } = t0;
  let T0;
  let T1;
  let T2;
  let t1;
  let t10;
  let t11;
  let t12;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== locations) {
    t12 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const zones = selectDemandZones(locations);
      if (zones.length === 0) {
        t12 = null;
        break bb0;
      }
      const first = zones[0].name ?? "";
      if (zones.length === 1) {
        t12 = <>{first}</>;
        break bb0;
      }
      const names = zones.map(_temp).filter(Boolean) as string[];
      T2 = TooltipProvider;
      t8 = 100;
      t9 = "TooltipProvider";
      t10 = "DemandLocationName";
      t11 = "DemandLocationName.tsx";
      T1 = Tooltip;
      t5 = "Tooltip";
      t6 = "DemandLocationName.tsx";
      t7 = <TooltipTrigger asChild={true} data-sentry-element="TooltipTrigger" data-sentry-source-file="DemandLocationName.tsx"><span className="cursor-default">{first} +{zones.length - 1}</span></TooltipTrigger>;
      T0 = TooltipContent;
      t3 = "TooltipContent";
      t4 = "DemandLocationName.tsx";
      t1 = "flex flex-col gap-0.5";
      t2 = names.map(_temp2);
    }
    $[0] = locations;
    $[1] = T0;
    $[2] = T1;
    $[3] = T2;
    $[4] = t1;
    $[5] = t10;
    $[6] = t11;
    $[7] = t12;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
  } else {
    T0 = $[1];
    T1 = $[2];
    T2 = $[3];
    t1 = $[4];
    t10 = $[5];
    t11 = $[6];
    t12 = $[7];
    t2 = $[8];
    t3 = $[9];
    t4 = $[10];
    t5 = $[11];
    t6 = $[12];
    t7 = $[13];
    t8 = $[14];
    t9 = $[15];
  }
  if (t12 !== Symbol.for("react.early_return_sentinel")) {
    return t12;
  }
  let t13;
  if ($[16] !== t1 || $[17] !== t2) {
    t13 = <ul className={t1}>{t2}</ul>;
    $[16] = t1;
    $[17] = t2;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== T0 || $[20] !== t13 || $[21] !== t3 || $[22] !== t4) {
    t14 = <T0 data-sentry-element={t3} data-sentry-source-file={t4}>{t13}</T0>;
    $[19] = T0;
    $[20] = t13;
    $[21] = t3;
    $[22] = t4;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== T1 || $[25] !== t14 || $[26] !== t5 || $[27] !== t6 || $[28] !== t7) {
    t15 = <T1 data-sentry-element={t5} data-sentry-source-file={t6}>{t7}{t14}</T1>;
    $[24] = T1;
    $[25] = t14;
    $[26] = t5;
    $[27] = t6;
    $[28] = t7;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== T2 || $[31] !== t10 || $[32] !== t11 || $[33] !== t15 || $[34] !== t8 || $[35] !== t9) {
    t16 = <T2 delayDuration={t8} data-sentry-element={t9} data-sentry-component={t10} data-sentry-source-file={t11}>{t15}</T2>;
    $[30] = T2;
    $[31] = t10;
    $[32] = t11;
    $[33] = t15;
    $[34] = t8;
    $[35] = t9;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  return t16;
}
function _temp2(name, i) {
  return <li key={i}>- {name}</li>;
}
function _temp(z) {
  return z.name;
}